// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"15fa124b","453":"7c9e0256","455":"60060d13","644":"afe8acfb"}[chunkId] + ".chunk.js";
};